import CompanyModel, {
  ClientsCharge,
  JobRole,
} from '@mm/state/model/CompanyModel';

export const enum SignUpFlowEventsTypes {
  SET_COMPANY = 'SET_COMPANY',
  START = 'START',
  GO_BACK = 'GO_BACK',
  SELECT_BILLING_PLAN = 'SELECT_BILLING_PLAN',
  SET_NEXT_STEP = 'SET_NEXT_STEP',
  SELECT_JOB_ROLE = 'SELECT_JOB_ROLE',
  SELECT_GOAL = 'SELECT_GOAL',
  SELECT_CLIENTS_CHARGE = 'SELECT_CLIENTS_CHARGE',
}

export type SetCompany = {
  type: SignUpFlowEventsTypes.SET_COMPANY;
  data: {
    company?: CompanyModel;
  };
};

export type StartEvent = {
  type: SignUpFlowEventsTypes.START;
  data: {
    name: string;
    businessEmail: string;
    website: string;
    phoneNumber: string;
    jobRole: string;
    clientsCharge: string;
    goal: string;
  };
};

export type GoBackEvent = {
  type: SignUpFlowEventsTypes.GO_BACK;
};

export type SelectBillingPlanEvent = {
  type: SignUpFlowEventsTypes.SELECT_BILLING_PLAN;
};

export type SetNextStepEvent = {
  type: SignUpFlowEventsTypes.SET_NEXT_STEP;
};
export type SelectClientsChargeEvent = {
  type: SignUpFlowEventsTypes.SELECT_CLIENTS_CHARGE;
  data: {
    clientsCharge: ClientsCharge;
  };
};
export type SelectJobRoleEvent = {
  type: SignUpFlowEventsTypes.SELECT_JOB_ROLE;
  data: {
    jobRole: JobRole;
  };
};

export type SelectGoalEvent = {
  type: SignUpFlowEventsTypes.SELECT_GOAL;
  data: {
    goal: string;
  };
};

export type SignUpFlowDataEvents =
  | SetCompany
  | StartEvent
  | SelectBillingPlanEvent
  | SelectGoalEvent
  | SelectJobRoleEvent
  | SelectClientsChargeEvent;

export type SignUpFlowEvents =
  | SignUpFlowDataEvents
  | GoBackEvent
  | SetNextStepEvent;
